import "./utils/polyfills";
import "swiper/swiper-bundle.css";
import { ThemeProvider } from "styled-components";
import { ThemeProvider as ChakraThemeProvider } from "@chakra-ui/react";
import "normalize.css";
import "./utils/yupLocale";
import "tippy.js/dist/tippy.css";
import "react-dates/lib/css/_datepicker.css";

import { NuqsAdapter } from "nuqs/adapters/react";
import { theme } from "./theme";
import CreatingCompanyProfile from "./newui/features/Auth";
import MainApp from "./MainApp";
import { selectGuestSwitch } from "newui/features/Auth/authSelectors";
import { useAppSelector } from "newui/store/hooks";
import { AuthContextProvider } from "newui/features/Auth/context/AuthContextProvider";

function App({ company, getGuestUser, ...props }) {
	const switchData = useAppSelector(selectGuestSwitch);

	return (
		<NuqsAdapter>
			<ThemeProvider theme={theme}>
				<ChakraThemeProvider theme={theme}>
					{switchData.is_loaded
						? <CreatingCompanyProfile />
						: <AuthContextProvider>
							<MainApp />
						</AuthContextProvider>}
				</ChakraThemeProvider>
			</ThemeProvider>
		</NuqsAdapter>
	);
}

export default App;
